import firebaseConfig from "../layouts/dev.firebase.config.js";
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  apiDomain: "https://strco.stringconsultants.com/api/",
  firebaseCDN: firebaseConfig,
  NODE_ENV: "Dev_Ops_strco",
};
